"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
__export(require("./components/ActionColumn"));
exports.basicFun = "()=> null";
exports.Loader = ({ row, col }) => {
    var _a, _b;
    return (react_1.default.createElement("span", { className: `${((_a = col.loader) === null || _a === void 0 ? void 0 : _a.styleClasses) || ""}` },
        react_1.default.createElement("i", { className: "fa fa-spin fa-spinner text-primary mr-2" }), (_b = col.loader) === null || _b === void 0 ? void 0 :
        _b.text));
};
//# sourceMappingURL=index.js.map